export interface IQuery { }

export class AccessShareQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.DataSharing.Shares.Queries.AccessShareQueryV1, TCh.Domain.DataSharing'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.DataSharing.Shares.Queries.AccessShareQueryV1, TCh.Domain.DataSharing'
	}

}

export class ActiveSharesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.DataSharing.Shares.Queries.ActiveSharesQueryV1, TCh.Domain.DataSharing'

	OrganizationUnitId: number

	constructor (organizationUnitId: number)
	{
		this.OrganizationUnitId = organizationUnitId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.DataSharing.Shares.Queries.ActiveSharesQueryV1, TCh.Domain.DataSharing'
	}

}

export class DataShareEmailsProvidersQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.DataSharing.Shares.Queries.DataShareEmailsProvidersQueryV1, TCh.Domain.DataSharing'

	OrganizationUnitId: string
	WorkspaceId: string | null
	ProjectId: string | null

	constructor (organizationUnitId: string, workspaceId: string | null, projectId: string | null)
	{
		this.OrganizationUnitId = organizationUnitId
		this.WorkspaceId = workspaceId
		this.ProjectId = projectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.DataSharing.Shares.Queries.DataShareEmailsProvidersQueryV1, TCh.Domain.DataSharing'
	}

}

export class EmailsAndGroupsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.DataSharing.Shares.Queries.EmailsAndGroupsQueryV1, TCh.Domain.DataSharing'

	OrganizationUnitId: string
	WorkspaceId: string | null
	ProjectId: string | null
	EmailsProviderName: string

	constructor (organizationUnitId: string, workspaceId: string | null, projectId: string | null, emailsProviderName: string)
	{
		this.OrganizationUnitId = organizationUnitId
		this.WorkspaceId = workspaceId
		this.ProjectId = projectId
		this.EmailsProviderName = emailsProviderName
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.DataSharing.Shares.Queries.EmailsAndGroupsQueryV1, TCh.Domain.DataSharing'
	}

}

export class ResourceSharesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.DataSharing.Shares.Queries.ResourceSharesQueryV1, TCh.Domain.DataSharing'

	ResourceProviderName: string
	ResourceId: string

	constructor (resourceProviderName: string, resourceId: string)
	{
		this.ResourceProviderName = resourceProviderName
		this.ResourceId = resourceId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.DataSharing.Shares.Queries.ResourceSharesQueryV1, TCh.Domain.DataSharing'
	}

}

export class ShareNotificationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.DataSharing.Shares.Queries.ShareNotificationQueryV1, TCh.Domain.DataSharing'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.DataSharing.Shares.Queries.ShareNotificationQueryV1, TCh.Domain.DataSharing'
	}

}

export class ShareQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.DataSharing.Shares.Queries.ShareQueryV1, TCh.Domain.DataSharing'

	ResourceProviderName: string
	ResourceId: string
	Id: string

	constructor (resourceProviderName: string, resourceId: string, id: string)
	{
		this.ResourceProviderName = resourceProviderName
		this.ResourceId = resourceId
		this.Id = id
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.DataSharing.Shares.Queries.ShareQueryV1, TCh.Domain.DataSharing'
	}

}

export class SharesForEmailQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.DataSharing.Shares.Queries.SharesForEmailQueryV1, TCh.Domain.DataSharing'

	Email: string

	constructor (email: string)
	{
		this.Email = email
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.DataSharing.Shares.Queries.SharesForEmailQueryV1, TCh.Domain.DataSharing'
	}

}

